/**
 * VocabTag — small labelled pill for the two halves of Giga One and their integration.
 * INTELLIGENCE (AGI / cognitive / orchestration) and PRODUCTION (physical / industrial /
 * manufacturing capacity) are equal partners — never hierarchical. FUSED signals
 * the integrated platform where both are owned as one.
 */
export default function VocabTag({ kind = "PRODUCTION", dark = false, className = "" }) {
  const isIntelligence = kind === "INTELLIGENCE";
  const isProduction = kind === "PRODUCTION";
  const isFused = kind === "FUSED";
  const color = dark ? "var(--g1-bone)" : "var(--g1-ink)";

  const label = isFused
    ? "/ FUSED"
    : isIntelligence
    ? "/ INTELLIGENCE"
    : "/ PRODUCTION";

  return (
    <span
      className={`inline-flex items-center gap-2 font-mono font-medium text-[10px] md:text-[11px] tracking-[0.24em] uppercase ${className}`}
      style={{ color }}
    >
      {isFused ? (
        <span aria-hidden className="inline-flex items-center gap-[3px]">
          <Glyph filled color={color} />
          <Glyph outlined color={color} />
        </span>
      ) : (
        <Glyph filled={isIntelligence} outlined={isProduction} color={color} accent={isIntelligence} />
      )}
      {label}
    </span>
  );
}

function Glyph({ filled, outlined, color, accent }) {
  return (
    <span
      aria-hidden
      className="inline-block"
      style={{
        width: 6,
        height: 6,
        borderRadius: 0,
        background: filled ? (accent ? "var(--g1-olive)" : color) : "transparent",
        outline: outlined ? "1px solid " + color : "none",
        outlineOffset: 1,
      }}
    />
  );
}
